import React from 'react';
import cn from '@/utils/cn';
import { IQuestion } from '@/components/staffer/Grading/types';
import { renderStimuli } from '@/components/staffer/Grading/utils';
import AnswerKey from '@/components/staffer/Grading/QuestionCards/AnswerKey';
import styles from '@/components/staffer/Grading/QuestionCards/questionCard.module.scss';

interface BaseQuestionModeCardProps {
  children: ReactChildren;
  question: IQuestion;
}

const BaseQuestionModeCard = ({ children, question }: BaseQuestionModeCardProps) => (
  <div className={styles.card}>
    <div className={styles.questionCardHeader}>
      Question
    </div>
    <div className={cn(styles.bodyWrapper, styles.noBorder)}>
      {renderStimuli(question)}
      {children}
      {question.type !== 'PromptOnly' && <AnswerKey question={question} />}
    </div>
  </div>
);

export default BaseQuestionModeCard;
